// Libraries
import { useId } from "react";
import { enqueueSnackbar } from "notistack";

// Layouts
import { SnackbarsActions, SnackbarsContent } from "@/Layouts/components/Snackbars";

function useSnackbar() {
	function snackBarsActions() {
		const key = useId();
		return <SnackbarsActions key={key} index={key} />;
	}

	function showSnackBar(message: string, critical = false) {
		enqueueSnackbar(<SnackbarsContent message={message} critical={critical} />, {
			variant: critical ? "error" : "success",
			preventDuplicate: true,
			action: snackBarsActions,
		});
	}

	return { showSnackBar };
}

export { useSnackbar };
